import { render } from "./App.vue?vue&type=template&id=27efed6d&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=27efed6d&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__